const PACK_CATALOG = [
  {
    canonicalName: "Starter",
    aliases: ["Starter", "Local"],
    price: "269 € / mes",
  },
  {
    canonicalName: "Basic",
    aliases: ["Basic"],
    price: "desde 379 € / mes",
  },
  {
    canonicalName: "Premium",
    aliases: ["Premium"],
    price: "desde 499 € / mes",
  },
  {
    canonicalName: "E-commerce",
    aliases: ["E-commerce", "Ecommerce"],
    price: "desde 589 € / mes",
  },
  {
    canonicalName: "Infoproducto",
    aliases: ["Infoproducto"],
    price: "desde 390 € / mes",
  },
];

const findPackEntry = (packName) => {
  if (!packName || typeof packName !== "string") {
    return null;
  }

  return (
    PACK_CATALOG.find(({ aliases }) => aliases.includes(packName.trim())) || null
  );
};

export const normalizePackRecommendation = (packData) => {
  if (!packData || typeof packData !== "object") {
    return packData;
  }

  const entry = findPackEntry(packData.nombre);
  if (!entry) {
    return packData;
  }

  return {
    ...packData,
    nombre: entry.canonicalName,
    precio: entry.price,
  };
};

export { PACK_CATALOG, findPackEntry };
